import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

type MeterialType = 'img' | 'video';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'material-tab',
  styleUrls: ['./icc-material-tab.component.less'],
  template: `
    <div class="tab-wrapper">
      <div class="tab" (click)="changeMenu(i)" *ngFor="let menu of menuList; let i = index" [ngClass]="{ active: i === actIndex }">
        {{ menu.name }}
      </div>
    </div>

    <div class="content-wrapper" *ngFor="let menu of menuList; let i = index">
      <!-- 图片 -->
      <div *ngIf="i === actIndex" class="content">
        <ng-container *ngIf="menu.type === 'img'">
          <div *ngIf="imgList.length < 1" (click)="selectMeterial('img')" class="upload" [ngStyle]="{ width: width + 'px', height: height + 'px' }">
            <i nz-icon nzType="upload" nzTheme="outline" class="ico"></i>
            <span>从素材库选择图片</span>
          </div>

          <div class="img-wrapper" *ngIf="imgList.length > 0">
            <icc-image-upload [width]="width" [imgList]="imgList" [editable]="false"></icc-image-upload>
            <icc-button (click)="retSelect(menu.type)" class="btn-sel">重新选择</icc-button>
          </div>
        </ng-container>

        <!-- 视频 -->
        <ng-container *ngIf="menu.type === 'video'">
          <div *ngIf="!videoUrl" (click)="selectMeterial('video')" class="upload" [ngStyle]="{ width: width + 'px', height: height + 'px' }">
            <i nz-icon nzType="upload" nzTheme="outline" class="ico"></i>
            <span>从素材库选择视频</span>
          </div>

          <div class="video-wrapper" *ngIf="videoUrl">
            <icc-video [disabled]="true" [url]="videoUrl"></icc-video>
            <icc-button (click)="retSelect(menu.type)" style="margin:10px 0" class="btn-sel">重新选择</icc-button>
          </div>
        </ng-container>
      </div>
    </div>
  `,
})
export class IccMaterialTabComponent implements OnInit {
  // 素材展示的宽度、高度
  @Input() width = 160;
  @Input() height = this.width;
  // 资源
  @Input() imgList = [];
  @Input() videoUrl = '';
  // 选择素材的回调
  @Output() selectEvent = new EventEmitter<MeterialType>();
  // 重新选择素材的回调
  @Output() retSelectEvent = new EventEmitter<MeterialType>();
  // 菜单
  menuList = [
    {
      name: '图片',
      type: 'img',
    },
    {
      name: '视频',
      type: 'video',
    },
  ];
  // 激活
  @Input()
  actIndex = 0;
  constructor() {}

  ngOnInit() {
    // 根据传入的数据判断当前激活项
    if (this.imgList.length) {
      this.actIndex = 0;
    } else if (this.videoUrl) {
      this.actIndex = 1;
    }
  }

  // 改变菜单
  changeMenu(val: number): void {
    this.actIndex = val;
  }
  // 选择素材
  selectMeterial(type: MeterialType) {
    this.selectEvent.next(type);
  }
  // 重新选择
  retSelect(type: MeterialType) {
    this.retSelectEvent.next(type);
  }
}
